export default axios => ({
  storeGprJobFact: (gprJobId, payload) => axios.post(`gpr-jobs/${gprJobId}/facts`, payload),
  storeGprJobFactForScaled: (gprJobId, payload) => axios.post(`scaled-gpr-jobs/${gprJobId}/facts`, payload)
})
